"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var mercadoPagoContainerStyles_1 = require("./mercadoPagoContainerStyles");
var FailedPaymentError_1 = require("../../ErrorPages/FailedPaymentError");
var MercadoPago_1 = require("./MercadoPago");
var useMercadoPago_1 = require("../../../hooks/useMercadoPago");
var MercadoPagoContainer = function (_a) {
    var goToNextStep = _a.goToNextStep, deal = _a.deal, loading = _a.loading;
    var styles = mercadoPagoContainerStyles_1.default();
    var _b = useMercadoPago_1.useMercadoPago(goToNextStep, deal, loading), isFailed = _b.isFailed, paymentId = _b.paymentId, getIframeUrl = _b.getIframeUrl;
    return (<>
      {isFailed ? (<FailedPaymentError_1.default />) : (<>
          {!paymentId && <MercadoPago_1.default />}
          <core_1.Box data-test="payment:mercadopago:iframe">
            <iframe src={getIframeUrl()} className={styles.container}/>
          </core_1.Box>
        </>)}
    </>);
};
exports.default = MercadoPagoContainer;
